<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2" v-bind:class="{'run-loading': loading}">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card title="User Access" class="mb-0 heig-frame-child">
                        <b-row align-v="center">
                            <b-col md="4">
                                <gofix-form-dropdown 
                                    label="Roles" 
                                    :clearable="false" 
                                    v-model="form.roles" 
                                    :options="userRoles" 
                                    vLabel="name" 
                                    :multiple="true" 
                                    show-icon-required
                                    required>
                                </gofix-form-dropdown>
                            </b-col>
                            <b-col md="4">
                                <gofix-button @click="submit" label="Generate" outline></gofix-button>
                            </b-col>
                        </b-row>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    
    export default {
        name: 'user-info',
        data () {
            return {
                loading: false,
                userRoles: [],
                form: {
                    contract_id: null,
                    roles: null
                }
            }
        },
        created () {
            this.getRoles();
            if(this.ClientContractID && this.ClientContractID.id) this.form.contract_id = this.ClientContractID.id;
        },
        watch:{
            ClientContractID: function(val) {
                this.form.contract_id = null;
                if(val && val.id) this.form.contract_id = val.id;
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        methods:{
            getRoles(){
                this.$store.dispatch("RoleController/getRoleItems",{
                    page: 1,
                    limit: -1,
                    filter : null
                })
                    .then(response => {
                        this.userRoles = response.items;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            submit() {
                if(!this.form.contract_id) return this.$alertNotification("Please select contract.", "danger");
                if(!this.form.roles || !this.form.roles.length) return this.$alertNotification("Please select roles.", "danger");
                this.loading = true;
                let request = JSON.parse(JSON.stringify(this.form));
                request.roles = request.roles.map(item => item.id);
                this.$store.dispatch('v2UserController/exportUserAccess', request)
                    .then(response => {
                        this.loading = false;
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'UserAccessReport.xlsx'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error);
                    })
            }
        }
    }
</script>
